import { useState, useEffect } from 'react';
import { query, collection, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useFetchData = (collectionPath, docId = null, queryParams = null) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                if (docId) {
                    const docRef = doc(db, collectionPath, docId);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        setData(docSnap.data());
                    } else {
                        setError('Document not found');
                    }
                } else if (queryParams) {
                    const colRef = collection(db, collectionPath);
                    const q = query(colRef, ...queryParams);
                    const querySnapshot = await getDocs(q);
                    const docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setData(docs);
                } else {
                    const colRef = collection(db, collectionPath);
                    const querySnapshot = await getDocs(colRef);
                    const docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    setData(docs);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (collectionPath) {
            fetchData();
        }
    }, [collectionPath, docId, queryParams]);

    return { data, loading, error };
};

export default useFetchData;
